module.exports = __webpack_public_path__ + "img/morrisons_coronavirus_colleague_bonus.0e4911d5.jpg";